import {connect} from '../../../../redux/utils'
import {showEditor} from '../selectors'
import {bindActionCreators} from 'redux'
import {ManagementAssignmentsEditorPanel} from '../../managementAssignmentsEditor/components/ManagementAssignmentsEditorPanel'
import CreateUserManagementAssignmentsEditor from './CreateUserManagementAssignmentsEditor'
import {cancelUserCreation} from '../../../../panels/user/createPanel/actions'
import {closeEditor} from '../../createUserManagementAssignmentsEditor/actions'

export class CreateUserManagementAssignmentsEditorPanel extends ManagementAssignmentsEditorPanel {
    constructor(params) {
        super({
            hierarchyAssignmentsEditor: new CreateUserManagementAssignmentsEditor(),
            extraClass: 'userManagement_managementAssignmentsEditorPanel createUserAssignmentPanel',
            ...params
        })
    }
}

export default connect(
    state => ({
        show: showEditor(state)
    }),
    dispatch => ({
        closeEditor: bindActionCreators(closeEditor, dispatch),
        closeAllPanels: bindActionCreators(cancelUserCreation, dispatch)
    })
)(CreateUserManagementAssignmentsEditorPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createUserManagementAssignmentsEditor/components/CreateUserManagementAssignmentsEditorPanel.js